import React from 'react';
import {useDrop} from "react-dnd";
import moment from "moment";
import DatePicker from "react-datepicker";
import _ from "lodash";
import Button from "react-bootstrap/Button";
import {itemTempValues} from "./TripCheckForm";

const DaysWrapper = ({day,children, setBaseData}) => {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: "Our first type",
    drop: () => ({ name: day.date }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    }),
  });

  const removeItem = () =>{
    if(window.confirm('Вы действительно хотите удалить день?')){
      setBaseData(prevData => {
        const copied = structuredClone(prevData.days)
        _.remove(copied, {date: day.date})
        return {...prevData, days: _.sortBy(copied, d => moment(d.date, 'DD.MM.YYYY').unix())}
      })
    }
  }

  const addNewItem = () =>{
    setBaseData(prevData => {
      const copied = structuredClone(prevData.days)
      const needDay = _.find(copied, {date: day.date})
      needDay.items.push({...itemTempValues, column: day.date})
      return {...prevData, days: copied}
    })
  }

  return (
    <div
      ref={drop}
    >
      <div className={'d-flex gap-1 align-items-center mb-2'}>
        <i className="la la-times pointer " onClick={removeItem}/>
        <DatePicker
          selected={moment(day.date, 'DD.MM.YYYY').toDate()}
          autoComplete='off'
          className={"form-control"}
          dateFormat={'dd.MM.yyyy'}
          locale={'ru'}
          calendarStartDay={1}
          onChange={date => {
            console.log('date', moment(date).format('DD.MM.YYYY HH:mm'))
            setBaseData(prevData => {
              const copied = structuredClone(prevData.days)
              const needArrayIndex = _.findIndex(prevData.days, {date: day.date})
              copied[needArrayIndex].date = moment(date).format('DD.MM.YYYY')
              return {...prevData, days: _.sortBy(copied, d => moment(d.date, 'DD.MM.YYYY').unix())}
            })
          }}
        />
        <Button variant={'outline-secondary'}
                onClick={addNewItem}>
          <i className="fa fa-plus ml-2"/>
        </Button>
      </div>

      {children}
    </div>
  );
};

export default DaysWrapper;
